<template>
  <div>
    <!-- Top Navigation Menu -->
    <div class="topnav">
      <div @click.prevent="toggleDisplaMenu" class="icon" v-click-outside="onClickOutSide">
        <div class="bars"></div>
        <div class="bars"></div>
        <div class="bars"></div>
        <div class="bars"></div>
      </div>
      <div v-if="show" id="myLinks" @click="selectPage">
        <router-link :to="{ name: 'home' }">Home</router-link>
        <router-link :to="{ name: 'features' }">{{
          $t("process_management")
        }}</router-link>
        <router-link :to="{ name: 'tasks' }">{{ $tc("task", 2) }}</router-link>
        <router-link :to="{ name: 'features/recruitment' }">{{
          $tc("recruitment", 1)
        }}</router-link>
        <router-link :to="{ name: 'resumes' }">{{ $tc("cv", 2) }}</router-link>
        <router-link :to="{ name: 'quotation' }">{{
          $t("quotation_and_purchase")
        }}</router-link>
        <router-link :to="{ name: 'plans' }">{{
          $tc("plan.label", 2)
        }}</router-link>
        <router-link :to="{ name: 'contact' }">{{
          $tc("contact.label", 1)
        }}</router-link>
        <router-link :to="{ name: 'create_account' }">{{
          $tc("action.create_account", 1)
        }}</router-link>
        <a href="https://system.processflex.com" target="_blank">{{
          $tc("login.label", 1)
        }}</a>
      </div>
    </div>
    <!-- <TranslateSelect class="d-md-none"/> -->
  </div>
</template>

<script>
export default {
  name: "MobileMenu",
  data: () => {
    return {
      show: false,
    };
  },
  methods: {
    toggleDisplaMenu() {
      this.show = !this.show;
    },
    selectPage() {
      this.show = false;
    },
	onClickOutSide() {
		this.show = false;
	}
  },
};
</script>

<style lang="scss" scoped>
.topnav {
  // width: 100%;
  // min-height: 50px;
  // overflow: hidden;
  position: absolute;
  right: 0px;
  top: 10px;
  z-index: 20;
  // margin-top: 20px;

  @media screen and (min-width: 779px) {
    display: none;
  }
}

.topnav #myLinks {
  margin-top: 40px;
  background-color: #333;
  opacity: 0.9;
}

.topnav a {
  color: white;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
  display: block;
}

.topnav .icon {
  display: block;
  margin-right: 10px;
  top: 0;
  width: 50px;
  float: right;

  .bars {
    text-align: right;
    margin-right: 10px;
    height: 1px;
    border: 1px solid #fff;
    margin-bottom: 5px;
  }
}

.active {
  background-color: #4caf50;
  color: white;
}
</style>
